module.exports = __webpack_public_path__ + "images/feature/table-insert-in-doc-1c5363e1306f3f7f343da7b93634e2d9.png";